import React from "react";
import CIcon from "@coreui/icons-react";
import {
  cilBell,
  cilCalculator,
  cilChartPie,
  cilCursor,
  cilDrop,
  cilNotes,
  cilPencil,
  cilPuzzle,
  cilSpeedometer,
  cilMoney,
  cilList,
  cilSpeech,
  cilSettings,
  cilEnvelopeClosed,
  cilStar,
  cilUserFemale,
  cilTransfer,
  cilDataTransferDown,
  cilDataTransferUp,
  cilChartLine,
  cilLoopCircular,
  cilWallet,
  cilGraph,
  cilVerticalAlignCenter,
  cibServerFault,
  cilUserPlus,
  cilBook,
} from "@coreui/icons";
import { CNavGroup, CNavItem, CNavTitle } from "@coreui/react";

const _nav = [
  {
    component: CNavItem,
    name: "Dashboard",
    to: "/dashboard",
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Users",
    to: "/userList",
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Depositors",
    to: "/depositors",
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Conversion Users",
    to: "/conversion-users",
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Assets",
    to: "/coin-list",
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: CNavGroup,
    name: 'Staking',
    icon: <CIcon icon={cilLoopCircular} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Stake List',
        to: '/stake-list',
        icon: <CIcon icon={cilList} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: 'Stake Order',
        to: '/stakeorder',
        icon: <CIcon icon={cilList} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: 'Stake Settle',
        to: '/stakesettle',
        icon: <CIcon icon={cilList} customClassName="nav-icon" />,
      },
    ],
  },
  {
    component: CNavItem,
    name: "Deposit",
    to: "/deposit-list",
    icon: <CIcon icon={cilDataTransferDown} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Withdrawals',
    to: '/withdraw-list',
    icon: <CIcon icon={cilDataTransferUp} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Meetings',
    to: '/meeting-list',
    icon: <CIcon icon={cilDataTransferUp} customClassName="nav-icon" />,
  },

  {
    component: CNavGroup,
    name: 'Trading',
    // to: '/Spot',
    icon: <CIcon icon={cilChartLine} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Pairs',
        to: '/pair-list',
        icon: <CIcon icon={cilList} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: 'Group Trading',
        to: '/group-trading',
        icon: <CIcon icon={cilList} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: 'Hedge Fund',
        to: '/hedge-list',
        icon: <CIcon icon={cilList} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: 'Closed PNL',
        to: '/closed-history',
        icon: <CIcon icon={cilList} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Open Trades",
        to: "/open-history",
        icon: <CIcon icon={cilList} customClassName="nav-icon" />,
      },
    ],
  },

  {
    component: CNavItem,
    name: "Settings",
    to: "/site-setting",
    icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
  },


  {
    component: CNavGroup,
    name: 'Price CNV',
    // to: '/Spot',
    icon: <CIcon icon={cilWallet} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Conversions',
        to: '/cnv-list',
        icon: <CIcon icon={cilList} customClassName="nav-icon" />,
      },
    ],
  },



  {
    component: CNavGroup,
    name: "Emails",
    // to: '/templateList',
    icon: <CIcon icon={cilEnvelopeClosed} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Email",
        to: "/templateList",
        icon: <CIcon icon={cilList} customClassName="nav-icon" />,
      },
      // {
      //   component: CNavItem,
      //   name: 'CMS Pages',
      //   to: '/cmsList',
      //   icon: <CIcon icon={cilList} customClassName="nav-icon" />,
      // },
    ],
  },

  // {
  //   component: CNavGroup,
  //   name: 'Admin Commission',
  //   icon: <CIcon icon={cilSpeech} customClassName="nav-icon" />,
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: 'Commission List',
  //       to: '/commission-list',
  //       icon: <CIcon icon={cilList} customClassName="nav-icon" />,
  //     },
  //   ],
  // },
  {
    component: CNavGroup,
    name: 'Support',
    // to: '/faq-category',
    icon: <CIcon icon={cilSpeech} customClassName="nav-icon" />,
    items: [
      // {
      //   component: CNavItem,
      //   name: 'FAQ Category',
      //   to: '/faq-category',
      //   icon: <CIcon icon={cilList} customClassName="nav-icon" />,
      // },

      {
        component: CNavItem,
        name: 'Category',
        to: '/support-category',
        icon: <CIcon icon={cilList} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: 'Support',
        to: '/support',
        icon: <CIcon icon={cilList} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: 'FAQ',
        to: '/faqlist',
        icon: <CIcon icon={cilList} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: 'Contact Us List',
        to: '/contact-list',
        icon: <CIcon icon={cilList} customClassName="nav-icon" />,
      },
    ],
  },


  {
    component: CNavItem,
    name: "CMS",
    to: "/cmsList",
    icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
  },


  {
    component: CNavItem,
    name: 'Live Events',
    to: '/live-eventes',
    icon: <CIcon icon={cilDrop} customClassName="nav-icon" />,
  },

  {
    component: CNavGroup,
    name: "Campaign",
    to: "/campaigner-Management",
    icon: <CIcon icon={cilUserPlus} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Campaigners",
        to: "/campaigner-list",
        icon: <CIcon icon={cilList} customClassName="nav-icon" />,
      },

      {
        component: CNavItem,
        name: "Campaign List",
        to: "/campaign-list",
        icon: <CIcon icon={cilList} customClassName="nav-icon" />,
      },
    ],
  },
  {
    component: CNavItem,
    name: "API Doc",
    to: "/api-doc",
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Campaigns Leads",
    to: "/campaigns-leads",
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Campaigns Deposit",
    to: "/campaigns-deposit",
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: CNavGroup,
    name: "Admin",
    to: "/admin-manage",
    icon: <CIcon icon={cilUserPlus} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Modules',
        to: '/modules',
        icon: <CIcon icon={cilList} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: 'SubModules',
        to: '/sub-modules',
        icon: <CIcon icon={cilList} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "AGENT",
        to: "/sub-admin",
        icon: <CIcon icon={cilList} customClassName="nav-icon" />,
      },

      {
        component: CNavItem,
        name: "Users Manage",
        to: "/users-manage",
        icon: <CIcon icon={cilList} customClassName="nav-icon" />,
      },
      // {
      //   component: CNavItem,
      //   name: 'Role Management',
      //   to: '/role-management',
      //   icon: <CIcon icon={cilList} customClassName="nav-icon" />,
      // },
    ],
  },

];

export default _nav;
